import QueryOverview from '../components/QuerySection/QueryOverview';
import QueryForm from '../components/QuerySection/QueryForm';
import ContactUs from '../components/ContactUs';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import WhatsAppChat from "../components/WhatsAppChat";

const Query = () => {
    return (
        <div>
            <Navbar />
            <QueryOverview />
            <QueryForm />
            <ContactUs />
            <FAQ />
            <Footer />
            <WhatsAppChat/>
        </div>
    );
};

export default Query;
